import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-4 pt-1"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "px-4 text-muted" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center mb-2 space-x-3"
}
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center font-semibold text-success-dark"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, " done ", -1)
const _hoisted_9 = {
  key: 1,
  class: "flex items-center font-semibold text-danger-dark"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, " close ", -1)
const _hoisted_11 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_12 = { class: "mb-1 text-muted" }
const _hoisted_13 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_14 = { class: "mb-1 text-muted" }
const _hoisted_15 = {
  key: 2,
  class: "px-4 pt-1"
}
const _hoisted_16 = { class: "mb-1 text-muted" }
const _hoisted_17 = {
  key: 3,
  class: "px-4 pt-1"
}
const _hoisted_18 = { class: "mb-1 text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_ExerciseTestCase = _resolveComponent("ExerciseTestCase")!
  const _component_CodeFragment = _resolveComponent("CodeFragment")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.executionResults?.state === 'internal_error')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("programming_exercise.internal_error")), 1))
      : _createCommentVNode("", true),
    (_ctx.executionResults?.tests)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.executionResults.tests.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("programming_exercise.results_ok_but_no_testcases")), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredExecutionResultsTests, (test, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'details-' + test.id,
              class: _normalizeClass(["px-6 -mx-2", { 'py-6': !_ctx.reduced, 'py-2': _ctx.reduced }])
            }, [
              (!_ctx.onlyErrors)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t("programming_exercise.testcase")) + " " + _toDisplayString(index + 1), 1),
                    (test.passed)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _hoisted_8,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("programming_exercise.passed")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("programming_exercise.not_passed")), 1)
                        ])),
                    (_ctx.reduced)
                      ? (_openBlock(), _createBlock(_component_Btn, {
                          key: 2,
                          variant: 'icon',
                          outline: true,
                          onClick: ($event: any) => (
							_ctx.testCaseDetailsVisibility[test.id] = !_ctx.testCaseDetailsVisibility[test.id]
						)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass([
								_ctx.testCaseDetailsVisibility[test.id]
									? 'material-icons'
									: 'material-icons-outlined',
							])
                            }, "visibility", 2)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", null, [
                (!_ctx.onlyErrors)
                  ? (_openBlock(), _createBlock(_component_ExerciseTestCase, {
                      key: 0,
                      small: true,
                      "test-case": _ctx.exerciseTestCase(test.id)
                    }, null, 8, ["test-case"]))
                  : _createCommentVNode("", true),
                (!test.passed && test.stdout)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("programming_exercise.test_failed_stdout")) + ": ", 1),
                      _createVNode(_component_CodeFragment, {
                        collapsible: true,
                        value: test.stdout,
                        small: true
                      }, null, 8, ["value"])
                    ]))
                  : _createCommentVNode("", true),
                (!test.passed && test.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("programming_exercise.test_failed_with_error")) + ": ", 1),
                      _createVNode(_component_CodeFragment, {
                        collapsible: true,
                        value: test.stderr || test.error,
                        small: true
                      }, null, 8, ["value"])
                    ]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, !_ctx.reduced || _ctx.testCaseDetailsVisibility[test.id]]
              ])
            ], 2))
          }), 128))
        ]))
      : (!!_ctx.executionResults && _ctx.executionResults.execution_error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("programming_exercise.code_errored")) + ":", 1),
            _createVNode(_component_CodeFragment, {
              collapsible: true,
              value: _ctx.executionResults?.execution_error
            }, null, 8, ["value"])
          ]))
        : (!!_ctx.executionResults && _ctx.executionResults.compilation_errors)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("programming_exercise.compilation_errored")) + ":", 1),
              _createVNode(_component_CodeFragment, {
                collapsible: true,
                value: String(_ctx.executionResults?.compilation_errors)
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true)
  ]))
}